export const ALL_LANGUAGES_REVIEWS_KEY = 'all';
export const FEEFO_POPUP_SCRIPT_ID = 'feefo-popup-script';
